import React, { useEffect, useState } from "react";
import { Tabs, Tab, Box, Typography } from "@material-ui/core";
import useRecentAgents from "../../../utils/useRecentAgents";
import PrdAgentLayout from "./Chat/PrdAgentLayout";
import ArtifactList from "./Artifacts/ArtifactList";
import "../../../assets/styles/css/pages/ia/prd-chat.css";

function TabPanel({ children, value, index }) {
    if (value !== index) return null;
    return <Box style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', minHeight: 0, height: '100%' }}>{children}</Box>;
}

export default function PRD() {
    const { trackAgent } = useRecentAgents();
    const [tab, setTab] = useState(0);

    useEffect(() => {
        trackAgent('prd');
    }, [trackAgent]);

    return (
        <Box display="flex" flexDirection="column" height="calc(100vh - 150px)" overflow="hidden">
            <Tabs
                value={tab}
                onChange={(_, newVal) => setTab(newVal)}
                indicatorColor="primary"
                textColor="primary"
                style={{ borderBottom: '1px solid #e5e7eb', flexShrink: 0 }}
            >
                <Tab label="Chat" />
                <Tab label="Artifacts" />
                <Tab label="Aprobaciones" />
            </Tabs>

            <TabPanel value={tab} index={0}>
                <PrdAgentLayout />
            </TabPanel>

            <TabPanel value={tab} index={1}>
                <ArtifactList />
            </TabPanel>

            <TabPanel value={tab} index={2}>
                <Box display="flex" alignItems="center" justifyContent="center" height="100%">
                    <Typography variant="body1" color="textSecondary">
                        Aprobaciones — Próximamente
                    </Typography>
                </Box>
            </TabPanel>
        </Box>
    );
}
